/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank6 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.588 10.957a12.8 12.8 0 0 1 .512-.759l1.3-1.79h-1.66l-1.18 1.63a7.017 7.017 0 0 0-.87 1.56c-.2.527-.3 1.017-.3 1.47 0 .554.103 1.027.31 1.42.213.394.517.697.91.91.4.207.877.31 1.43.31.54 0 1.007-.106 1.4-.32.4-.213.707-.513.92-.9.22-.393.33-.853.33-1.38 0-.493-.09-.916-.27-1.27a1.885 1.885 0 0 0-.76-.82c-.327-.193-.717-.29-1.17-.29-.33 0-.631.077-.902.229zm-.68 1.681a1.48 1.48 0 0 1 .452-.53c.227-.16.487-.24.78-.24.22 0 .41.054.57.16.16.1.283.247.37.44.087.187.13.41.13.67 0 .414-.107.74-.32.98-.207.24-.49.36-.85.36-.367 0-.653-.116-.86-.35-.207-.233-.31-.556-.31-.97 0-.173.012-.346.037-.52z" />
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgRank6 as Rank6 };
